import { twMerge } from "tailwind-merge";
import { Type } from "@shared/ui/Type";

export type Props = {
  className?: string;
};

export function SchedulingInstructions({ className }: Props) {
  return (
    <div className={twMerge("flex flex-col gap-4 px-4", className)}>
      <Type variant="h4">Instructions</Type>
      <Type variant="body2">
        Choose at least 10 hours over the week (in 2+ hour slots). For best
        matching results, select 14+ hours.
      </Type>
      <Type variant="body2">
        In the calendar grid, tap on a cell to indicate your availability. Tap
        and drag to select multiple slots. Slots are only valid when they are 2
        hours or more.
      </Type>
      <Type variant="body2">
        You can add to or edit these selections up until September 9.
      </Type>
    </div>
  );
}

export default SchedulingInstructions;
